import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-switch-off",
  "use": "icon-ib-switch-off-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-switch-off\">\r\n    <path d=\"M512 768a256 256 0 1 1 0-512 256 256 0 0 1 0 512z m0 85.333333a341.333333 341.333333 0 1 0 0-682.666666 341.333333 341.333333 0 0 0 0 682.666666z\" p-id=\"6620\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol